$(document).ready(function () {
	$('.mobile-wrap').on('click', function () {
		$('.line-burger').toggleClass('line-active');
		$('.header__list').slideToggle();
	});

	$(window).resize(function () {
		if ($(window).width() >= 1199) {
			$('.header__list').attr('style', '');
			$('.line-burger').removeClass('line-active');
		}
	});

	function validate(input, length, regExp, error, phone) {

		$(input).on('blur keyup', function () {
			var value = $(this).val();
			var that = $(this);

			regExp = regExp == '' ? /./ : regExp;

			if (phone === true) {
				bool_reg = !regExp.test(value);
			} else {
				bool_reg = regExp.test(value);
			}

			if (value.length > length && value !== '' && bool_reg) {
				that.removeClass('form-fail').addClass('form-done');
				$(error).slideUp();
			} else {
				that.removeClass('form-done').addClass('form-fail');
				$(error).slideDown();
			}
		});
	}

	// деакцивация кнопки если есть поле с ошибкой

	function disBtn(input, btn, bool) {
		var input = $(input);
		input.on('blur keyup', function () {

			if (input.hasClass('form-fail') || bool == true) {
				$(btn).attr('disabled', 'disabled');
			} else {
				$(btn).removeAttr('disabled');
			}

		});
	}

	// для проверки при нажатии

	function valClick(input, length, regExp, error, phone) {
		var value = $(input).val();

		regExp = regExp == '' ? /./ : regExp;

		if (phone === true) {
			bool_reg = regExp.test(value);
		} else {
			bool_reg = !regExp.test(value);
		}

		if (value.length < length || value === '' || bool_reg) {
			$(input).addClass('form-fail');
			$(error).slideDown();
		}
	}

	//  деакцивация кнопки при нажатии

	function disBtnClick(input, btn) {
		var input = $(input);

		if (input.hasClass('form-fail')) {
			$(btn).attr('disabled', 'disabled');
			return false;
		} else {
			return true;
		}
	}

	$('input[type="tel"]').mask("+38 (999) 999-99-99");

	var regName = /^[a-zA-Zа-яА-ЯёЁєЄIiЇї'`]+/;
	var regEmail = /[-.\w]+@[-.\w]+\.[-.\w]+/i;
	var regPhone = /[_]/i;

	$('#c_btn').on('click', function () {
		sendForm();
		return false;
	});

	function sendForm() {
		var name = $('#c_name').val();
		var email = $('#c_email').val();
		var phone = $('#c_phone').val();
		var msg = $('#c_msg').val();

		validate('#c_name', 1, regName, '.contacts__error--name');
		validate('#c_email', 1, regEmail, '.contacts__error--email');
		validate('#c_phone', 1, regPhone, '.contacts__error--phone', true);
		disBtn('#c_name, #c_email, #c_phone', '#c_btn');

		valClick('#c_name', 1, regName, '.contacts__error--name');
		valClick('#c_email', 1, regEmail, '.contacts__error--email');
		valClick('#c_phone', 1, regPhone, '.contacts__error--phone', true);
		var btn_bool = disBtnClick('#c_name, #c_email, #c_phone', '#c_btn');

		if (btn_bool) {
			$.ajax({
				url: themeVar.url,
				type: 'POST',
				data: {
					action: 'contact',
					name: name,
					email: email,
					phone: phone,
					msg: msg,
				},
			}).done(function (data) {
				$('#c_name, #c_email, #c_phone, #c_msg').val('').removeClass('form-done');
				var text = 'Ваше повідомлення відправлене!';

				$('.msg-modal').html(text).addClass('msg-modal-active');
				setTimeout(function () {
					$('.msg-modal').removeClass('msg-modal-active');
				}, 2500);
			});
		}
	}

});

$(document).on('click', '.header__link, .footer__link, .js-btn-anchor', function (e) {
	let target = $(this).attr('href');
	let pos = target.indexOf('#');
	if (pos !== -1) {
		target = target.substring(pos);
		let coordsScroll = $(target).offset().top;
		if ($(window).width() <= 1199) {
			let headerHeight = $('.header').outerHeight();
			coordsScroll -= headerHeight;
		}
		$('html, body').animate({
			scrollTop: coordsScroll
		}, 800);
		if ($(window).width() <= 1199 && $(this).hasClass('header__link')) {
			$('.header__list').slideUp();
			$('.line-burger').removeClass('line-active');
		}
		return false;
	}
});

$('.read').on('click', function (e) {
	e.preventDefault();

	let $btn = $(this);

	let $target = $('.scroll-block').filter(function () {
		return $(this).offset().top > $btn.offset().top;
	}).first();

	if ($target.length) {
		let headerHeight = $(window).width() < 1200 ? $('.header').outerHeight() + 20 : 0;
		$('html, body').animate({
			scrollTop: $target.offset().top - headerHeight
		}, 600);
	}
});